import { Button as MuiButton, Tooltip } from '@mui/material';
import { colors, Typography } from '@sweep-io/sweep-design';

export const ViewInSalesforceButton = ({
  viewInSalesforceLink,
  disabled,
}: {
  viewInSalesforceLink: string;
  disabled?: boolean;
}) => {
  return (
    <Tooltip
      title={'Deploy your first model to view attribution data.'}
      placement="top"
      disableHoverListener={!disabled}
    >
      <span>
        <MuiButton
          disabled={disabled}
          variant="squared"
          size="small"
          sx={{
            background: disabled ? `${colors.grey[120]} !important` : colors.blue[100],
            whiteSpace: 'nowrap',
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            flexWrap: 'nowrap',
            height: '32px',
            borderRadius: '2px',
            borderColor: disabled ? colors.grey[500] : colors.blue[500],
          }}
          onClick={() => window.open(viewInSalesforceLink, '_blank')}
        >
          <Typography variant="body-medium" color={disabled ? colors.grey[500] : colors.blue[500]}>
            View in Salesforce
          </Typography>
        </MuiButton>
      </span>
    </Tooltip>
  );
};
